import DataService from './data-service';

export default class API extends DataService {
  constructor(options) {
    super({
      authStoreKey: options.authStoreKey,
      baseUrl: '/stage-ajax/api/v1',
      requestParams: {
        'stage-language': document.documentElement.lang || 'fi'
      }
    });
  }

  /**
   * Get personnel from API
   * @param {object} params required
   * @param {number} params.limit limit result (required)
   * @return {array}
   */
  getPersonnel(params) {
    return super.get('/personnel', params);
  }

  /**
   * Get offices from API
   * @param {object} params required
   * @param {number} params.limit limit result (required)
   * @return {array}
   */
  getOffices(params) {
    return super.get('/offices', params);
  }

  /**
   * Get blog articles from API
   * @param {object} params required
   * @param {number} params.limit limit result (required)
   * @return {array}
   */
  getBlogArticles(params) {
    return super.get('/blog', params);
  }

  /**
   * Get news from API
   * @param {object} params required
   * @param {number} params.limit limit result (required)
   * @return {array}
   */
  getNews(params) {
    return super.get('/news-and-events', params);
  }

  /**
   * Get knowledge articles from API
   * @param {object} params required
   * @param {number} params.limit limit result (required)
   * @return {array}
   */
  getArticles(params) {
    return super.get('/articles', params);
  }

  /**
   * Get references from API
   * @param {object} params required
   * @param {number} params.limit limit result (required)
   * @return {array}
   */
  getReferences(params) {
    return super.get('/references', params);
  }

  /**
   * Get careers from API
   * @param {object} params required
   * @param {number} params.limit limit result (required)
   * @return {array}
   */
  getCareers(params) {
    return super.get('/careers', params);
  }

  /**
   * Get stock exchange releases from API
   * @param {object} params required
   * @param {number} params.limit limit result (required)
   * @return {array}
   */
  getStockExchange(params) {
    return super.get('/stock-exchange-releases', params);
  }

  /**
   * Get file download from API
   * @param {object} params required
   * @param {string} params.token stage token (required)
   * @param {string} params.stageUrl stage url of file (required)
   * @return {array}
   */
  getDownload(params) {
    return super.get('/download', params);
  }

  /**
   * Get presentation and publications from API
   * @param {object} params required
   * @param {number} params.limit limit result (required)
   * @return {array}
   */
  getPresentationAndPublications(params) {
    return super.get('/presentation-and-publications', params);
  }

  /**
   * Get search results from API
   * @param {object} params required
   * @param {string} params.keyword search keyword (required)
   * @return {array}
   */
  getSearchResults(params) {
    return super.get('/addsearch', params);
  }

  /**
   * Get tech spec languages from API
   * @param {object} params required
   * @param {string} params.type product type (required)
   * @param {string} params.slug product slug (required)
   * @return {array}
   */
  getTechSpecLanguages(params) {
    return super.get('/tech-spec-languages', params);
  }
}
